var render, staticRenderFns
import script from "./v-keypress.vue?vue&type=script&lang=js"
export * from "./v-keypress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3ebe38",
  null
  
)

export default component.exports